/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { ConnectionStateBanner, InternetExplorerBanner } from 'components/banners';
import { bindActionCreators } from 'redux';
import { enqueue, dequeue } from 'reducers/banners';

/* The banner containers is there to manage banners.
 * We only want to show one banner at a time, to orchestrate this
 * the banner container uses a prioritize queue in a form of a redux store.
 *
 * Here's an example of a banner that would display for 5 seconds:
 *
 * class SomeBanner extends React.Component {
 *   props = {
 *     authorized: boolean,
 *     requestAuthorization: Function,
 *     releaseAuthorization: Function,
 *   }
 *
 *   componentDidMount() {
 *     this.props.requestAuthorization();
 *     setTimeout(this.props.releaseAuthorization, 5000);
 *   }
 *
 *   render() {
 *     if (!this.props.authorized) {
 *       return null;
 *     }
 *
 *     return <Banner>some banner</Banner>;
 *   }
 * }
 *
 * Banner can listen to whatever store(s) they wish to. If so,
 * you usually want to call the authorization functions from the
 * componentDidUpdate hooks, looking at the new values from the stores.
 */

const HIGH_PRIORITY = 0;
const NORMAL_PRIORITY = 1; // eslint-disable-line

type Props = {
  queueHead: ?string,
  enqueue: (key: string, priority: number) => any,
  dequeue: (key: string) => any,
};

class BannersContainer extends React.Component<Props> {
  render() {
    return (
      <div data-test="banners-container">
        <InternetExplorerBanner
          authorized={this.props.queueHead === 'ie_banner'}
          requestAuthorization={() => this.props.enqueue('ie_banner', NORMAL_PRIORITY)}
          releaseAuthorization={() => {}}
        />
        <ConnectionStateBanner
          authorized={this.props.queueHead === 'connection_state_banner'}
          requestAuthorization={() => this.props.enqueue('connection_state_banner', HIGH_PRIORITY)}
          releaseAuthorization={() => this.props.dequeue('connection_state_banner')}
        />
      </div>
    );
  }
}

function mapStateToProps(state: Object) {
  return {
    queueHead: state.banners.queueHead,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ enqueue, dequeue }, dispatch);
}

export { BannersContainer };
export default connect(mapStateToProps, mapDispatchToProps)(BannersContainer);
